import { useFelaEnhanced } from '@ackee/fela';
import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { routes } from 'config/routes';
import { Button, DynamicContainer, LocalizedLink, Text, TextTypes, Title, TitleTypes } from 'modules/ui';

import { PixelatedBackgroundContext } from 'modules/homepage/PixelatedBackgroundWrapper/PixelatedBackgroundWrapper';

import { BookingModal } from './BookingModal';
import { Image } from './Image';

import * as felaRules from './BookCallSection.rules';

export interface BookCallSectionProps {
    hasPaddingBottom?: boolean;
    modalVariant?: boolean;
    ref?: React.RefObject<HTMLDivElement>;
    titleAsComponent?: React.ElementType;
}

export const BookCallSection = ({
    hasPaddingBottom,
    modalVariant = true,
    ref,
    titleAsComponent = TitleTypes.H3,
}: BookCallSectionProps) => {
    const backgroundMode = useContext(PixelatedBackgroundContext);
    const { styles } = useFelaEnhanced(felaRules, { hasPaddingBottom, backgroundMode });
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <DynamicContainer
                isFluid
                hasPaddingBottom={hasPaddingBottom}
                extend={{ container: felaRules.extendMainWrapper }}
                ref={ref}
            >
                <div className={styles.container}>
                    <div>
                        <div className={styles.textContainer}>
                            {/* @ts-expect-error */}
                            <Title as={titleAsComponent} type={TitleTypes.H5}>
                                <FormattedMessage
                                    id={modalVariant ? 'bookCallSection.modalText' : 'bookCallSection.text'}
                                />
                            </Title>
                        </div>
                        {modalVariant ? (
                            <Button extend={{ button: felaRules.extendButton }} onClick={() => setModalOpen(true)}>
                                <FormattedMessage id="bookCallSection.modalCta" />
                            </Button>
                        ) : (
                            <LocalizedLink eventId="contact-home-bottom" to={routes['/contact']}>
                                <Button extend={{ button: felaRules.extendButton }}>
                                    <FormattedMessage id="bookCallSection.cta" />
                                </Button>
                            </LocalizedLink>
                        )}
                    </div>

                    <div className={styles.imageSection}>
                        <div className={styles.imageDescription}>
                            {/* @ts-expect-error */}
                            <Text type={TextTypes.NORMAL}>
                                <FormattedMessage id="bookCallSection.person.name" />
                            </Text>
                            {/* @ts-expect-error */}
                            <Text type={TextTypes.SMALL} extend={{ text: felaRules.extendPersonPositionText }}>
                                <FormattedMessage id="bookCallSection.person.position" />
                            </Text>
                        </div>
                        <div className={styles.image}>
                            <Image alt="bookCallSection.person.name" />
                        </div>
                    </div>
                </div>
            </DynamicContainer>
            <BookingModal open={modalOpen} setOpen={setModalOpen} />
        </>
    );
};
